var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "646BCC20-4E18-4846-B330-12AFB2534C31") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rides---Reservations",
    transform: "translate(-176.000000, -374.000000)",
    stroke: "#A1A5B3",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "row-copy",
    transform: "translate(149.000000, 343.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(23.000000, 27.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "card-icon/ride-id"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(5.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeLinejoin: "round",
    x: 0,
    y: 0,
    width: 15,
    height: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,11 C3.26933075,8.55260153 4.46934671,7.3289023 6.60004788,7.3289023 C8.73074905,7.3289023 10.1973998,6.2192682 11,4",
    id: "Path-3"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRide);
export default __webpack_public_path__ + "static/media/ride.4d1fb90f06ddc97d017e7e9f12965814.svg";
export { ForwardRef as ReactComponent };